import Reveal from "@/components/base/Reveal";
import { aboutMission } from "@/mocks/about";

export default function AboutMission() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <div className="relative overflow-hidden rounded-xl border border-background-300 bg-primary-950 p-8 md:p-14">
            <div className="pointer-events-none absolute inset-0 grid-paper opacity-[0.08]" aria-hidden="true" />
            <span
              className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
              aria-hidden="true"
            />
            <div
              className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-primary-800/50 blur-3xl"
              aria-hidden="true"
            />
            <div className="relative grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
              <div className="lg:col-span-7">
                <span className="inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.24em] text-accent-300">
                  <span className="h-px w-7 bg-accent-400" aria-hidden="true" />
                  {aboutMission.eyebrow}
                </span>
                <h2 className="mt-5 font-heading text-3xl font-medium leading-tight tracking-tight text-background-50 md:text-4xl">
                  {aboutMission.title}
                </h2>
                <p className="mt-6 border-l-2 border-accent-400/70 pl-5 font-heading text-lg leading-relaxed text-background-100 md:text-xl">
                  {aboutMission.quote}
                </p>
                <p className="mt-6 text-sm leading-relaxed text-background-200/80 md:text-base">
                  {aboutMission.note}
                </p>
              </div>
              <div className="lg:col-span-5">
                <ul className="flex flex-col gap-3">
                  {aboutMission.pillars.map((pillar) => (
                    <li
                      key={pillar}
                      className="flex items-center gap-3 rounded-md border border-background-50/15 bg-background-50/5 px-4 py-3"
                    >
                      <i className="ri-check-line text-base text-accent-400" aria-hidden="true" />
                      <span className="text-sm text-background-100">{pillar}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}